export default __webpack_public_path__ + "static/media/p3.f814584d.PNG";